import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import EnergyResourcesIcon from "../../../Common/Svgs/EnergyResourcesIcon";
import ChevronIcon from "../../../Common/Svgs/ChevronIcon";
import { useEnergyResourcesItem } from "./useItems";
import { SUBMENU } from "../data/contants";

const EnergyManagementItem = ({
  sidebarActive,
  pageName,
  subMenu,
  setSubMenu,
  // setSidebarActive,
}) => {
  const navigate = useNavigate();

  // sub menu items
  const items = useEnergyResourcesItem().filter((item) => item.hasPermission);

  const [hover, setHover] = useState(false);

  const activeItem = items.findIndex(
    (i) => i.label.toLowerCase() === pageName.toLowerCase(),
  );

  const handleSubMenu = () => {
    // setSidebarActive(true);

    if (subMenu === SUBMENU.ENERGY_RESOURCES) {
      setSubMenu(SUBMENU.DEFAULT);
    } else {
      setSubMenu(SUBMENU.ENERGY_RESOURCES);
    }
  };

  const getContainerStyle = () => {
    // sidebar is closed
    if (!sidebarActive) {
      // if energy resources submenu is open
      if (subMenu === SUBMENU.ENERGY_RESOURCES) {
        return "w-[231px] bg-primary rounded-t-md";
      }

      // if hovering
      if (hover) {
        return "w-[214px] bg-primary rounded-md";
      }
    }

    // sidebar is open
    if (sidebarActive) return "bg-primary-50";

    // default
    return "w-full";
  };

  const getHeaderMenuStyle = () => {
    // sidebar is closed
    if (!sidebarActive) {
      // if hovering over the menu item or the submenu is open
      if (hover || subMenu === SUBMENU.ENERGY_RESOURCES) {
        return "ml-2 text-sidebar-active stroke-sidebar-active";
      }
    }

    if (activeItem > -1 || subMenu === SUBMENU.ENERGY_RESOURCES) {
      return "text-sidebar-active stroke-sidebar-active";
    }

    return "text-sidebar-base stroke-sidebar-base";
  };

  // container of the submenu
  const getSubMenuContainerStyle = () => {
    if (!sidebarActive && subMenu === SUBMENU.ENERGY_RESOURCES) {
      return "absolute ml-[71px] w-[160px] bg-primary border border-white rounded-br-md";
    }

    return "";
  };

  const getSubMenuStyle = (item) => {
    if (pageName.toLowerCase() === item.toLowerCase()) return "text-primary";
    return "text-sidebar-base group-hover:text-sidebar-active";
  };

  useEffect(() => {
    // close the submenu if the sidebar is closed
    if (!sidebarActive) setSubMenu(SUBMENU.DEFAULT);

    // open the submenu if the sidebar is open and active item is present
    if (sidebarActive && activeItem > -1) {
      setTimeout(() => {
        setSubMenu(SUBMENU.ENERGY_RESOURCES);
      }, 200);
    }
  }, [sidebarActive, setSubMenu, activeItem]);

  return (
    <div className="relative">
      <div
        role="button"
        className={`flex items-center mt-5 py-2 px-6 h-9 cursor-pointer group ${getContainerStyle()}`}
        onClick={handleSubMenu}
        onMouseEnter={() => {
          if (subMenu === SUBMENU.DEFAULT) {
            setHover(true);
          }
        }}
        onMouseLeave={() => setHover(false)}
      >
        <motion.div className="w-5 h-5">
          <EnergyResourcesIcon
            className={`group-hover:text-sidebar-active shrink-0 ${getHeaderMenuStyle()}`}
          />
        </motion.div>

        {(sidebarActive || hover || subMenu === SUBMENU.ENERGY_RESOURCES) && (
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            className={`w-full ml-2 flex-1 font-aileron font-semibold text-xs group-hover:text-sidebar-active ${getHeaderMenuStyle()}`}
          >
            Energy Management
          </motion.p>
        )}

        {(sidebarActive || hover || subMenu === SUBMENU.ENERGY_RESOURCES) && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="w-2.5 h-2.5"
          >
            <ChevronIcon
              strokeWidth="1.5"
              className={`w-2.5 h-2.5 group-hover:stroke-sidebar-active transform transition-all ${getHeaderMenuStyle()}
              ${
                subMenu === SUBMENU.ENERGY_RESOURCES
                  ? "-rotate-90"
                  : "rotate-90"
              }
            `}
            />
          </motion.div>
        )}
      </div>

      <div
        className={`overflow-hidden ${getSubMenuContainerStyle()}`}
        style={{
          boxShadow:
            !sidebarActive && subMenu === SUBMENU.ENERGY_RESOURCES
              ? "12px 12px 16px -4px #10182814"
              : "none",
        }}
      >
        {subMenu === SUBMENU.ENERGY_RESOURCES &&
          items.map((i) => {
            const selected = pageName.toLowerCase() === i.label.toLowerCase();

            return (
              <div
                key={i.label}
                className={`flex items-center gap-x-2 py-3 px-[30px] cursor-pointer group ${
                  selected && "bg-sidebar-active"
                }`}
                onClick={() => navigate(i.path)}
              >
                <span className={`w-4 h-4 ${getSubMenuStyle(i.label)}`}>
                  {i.icon}
                </span>
                <p
                  className={`font-aileron text-xs font-normal capitalize ${getSubMenuStyle(
                    i.label,
                  )}`}
                >
                  {i.label}
                </p>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default EnergyManagementItem;
